module.exports = __webpack_public_path__ + "static/img/1.ab328c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/1.png
// module id = J/ze
// module chunks = 0